import * as Yup from 'yup';


const emptyError = 'Por favor llena todos los campos antes de continuar';

export  const schema1 = Yup.object().shape({
    email: Yup.string().email('Por favor, llenar el campo con un correo valido.')
        .required(emptyError),
    password: Yup.string()
        .required(emptyError)
        .min(8, `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`)
        .max(16, `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`)
});



export const schema2 = Yup.object().shape({
    email: Yup
        .string().email('Por favor, llenar el campo con un correo valido.')
        .required(emptyError)
});


export const recoverPass = Yup.object().shape({
    password: Yup.string()
        .required(emptyError)
        .min(8, `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`)
        .max(16, `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`),
    confirmPassword: Yup.string()
        .required(emptyError)
        .min(8, `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`)
        .max(16, `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`)
        .oneOf([Yup.ref('password'), null], 'La confirmación debe coincidir con la nueva contraseña')
});

